var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { useLocalization } from '@progress/kendo-react-intl';
import { messages, moreEvents } from '../messages';
import { moreHorizontalIcon } from '@progress/kendo-svg-icons';
/**
 * @hidden
 */
export var ShowMoreItemsButton = React.forwardRef(function (props, ref) {
    var btn = React.useRef(null);
    var element = React.useRef(null);
    var localization = useLocalization();
    React.useImperativeHandle(btn, function () { return (__assign({ element: element.current && element.current.element }, props)); });
    React.useImperativeHandle(ref, function () { return btn.current; });
    var handleClick = React.useCallback(function (syntheticEvent) {
        if (!props.onClick || !btn.current) {
            return;
        }
        props.onClick.call(undefined, {
            target: btn.current,
            syntheticEvent: syntheticEvent
        });
    }, [
        btn,
        props.slot,
        props.onClick
    ]);
    var moreEventsLabel = localization.toLanguageString(moreEvents, messages[moreEvents]);
    return (React.createElement(Button, { ref: element, tabIndex: -1, className: "k-more-events", onClick: handleClick, "aria-label": moreEventsLabel, icon: 'more-horizontal', svgIcon: moreHorizontalIcon }));
});
ShowMoreItemsButton.displayName = 'KendoReactSchedulerShowMoreItemsButton';
